import { createInputs } from '../../utils';

export default createInputs([
  { name: 'variant', type: 'string', enum: ['NORMAL', 'INVERT'] },
  { name: 'size', type: 'string', enum: ['SM', 'MD', 'LG'] },
]);
